import React from 'react';

const Movie = () => {
  return <a href="/myMoovie" className="movie">Moovie</a>;
};

export default Movie;
